const functions = require("../functions").default;

export function validationEvents(context) {
    // Select PF/PJ e Cliente construcao
    $(".js-select-pj", context).on("change", function () {
        const tipoPessoa = $(this).val();
        functions.atualizarMascara(tipoPessoa, context);
        functions.controlarVisibilidade(tipoPessoa, context);
    });

    // Checkbox PF(1)/PJ(3)
    $(".js-change-pj", context).on("change", function () {
        const tipoPessoa = $(this).is(":checked") ? "3" : "1";
        functions.atualizarMascara(tipoPessoa, context);
        functions.controlarVisibilidade(tipoPessoa, context);
    });

    $(".js-cpf-cnpj", context).on("change", function () {
        const valor = $(this).val();
        $("#cpf-cnpj-invalido", context).remove();
        if (!valor) {
            return;
        }
        if (
            $(".js-change-pj").is(":checked") ||
            $(".js-select-pj").val() == "3" ||
            $(".js-select-pj").val() == "4"
        ) {
            if (!isValidCNPJ(valor)) {
                const div = $(this).closest("div");
                div.append(
                    '<small class="a-color-taxa-perda" id="cpf-cnpj-invalido">CNPJ inválido!</small>'
                );
                if (!$(this).hasClass("is-invalid")) {
                    $(this).addClass("is-invalid");
                }
            } else {
                if ($(this).hasClass("is-invalid")) {
                    $(this).removeClass("is-invalid");
                }

                buscarRegistroCliente("cnpj", valor, context);
            }
        } else {
            if (!isValidCPF(valor)) {
                const div = $(this).closest("div");
                div.append(
                    '<small class="a-color-taxa-perda" id="cpf-cnpj-invalido">CPF inválido!</small>'
                );
                if (!$(this).hasClass("is-invalid")) {
                    $(this).addClass("is-invalid");
                }
            } else {
                if ($(this).hasClass("is-invalid")) {
                    $(this).removeClass("is-invalid");
                }

                buscarRegistroCliente("cnpj", valor, context, $(this));
            }
        }
    });

    $(".js-validar-cpf-cnpj", context).on("change", function () {
        window.removerMascaraCnpj(this);
        if ($(this).hasClass("is-invalid")) {
            $(this).removeClass("is-invalid");
        }
        let valor = $(this).val();
        const valorCpf = valor.replace(/\D/g, "");
        const valorCnpj = window.cleanCnpjInput(valor);
        const lengthCpf = valorCpf.length;
        const lengthCnpj = valorCnpj.length;
        if (lengthCnpj > 11) {
            window.mascaraCnpj(this);
            $(this).val(window.formatCnpjMasked(valor));
            if (!isValidCNPJ($(this).val())) {
                if (!$(this).hasClass("is-invalid")) {
                    $(this).addClass("is-invalid");
                }
            } else {
                if ($(this).hasClass("is-invalid")) {
                    $(this).removeClass("is-invalid");
                }
                $(".js-is-pj").val(1);
            }
        } else if (lengthCpf === 11) {
            window.removerMascaraCnpj(this);
            $(this).mask("000.000.000-00", {
                reverse: true,
            });
            if (!isValidCPF(valorCpf)) {
                if (!$(this).hasClass("is-invalid")) {
                    $(this).addClass("is-invalid");
                }
            } else {
                if ($(this).hasClass("is-invalid")) {
                    $(this).removeClass("is-invalid");
                }
                $(".js-is-pj").val(0);
            }
        }
    });
    $(".js-validar-sub-cpf-cnpj").on("submit", function (event) {
        event.preventDefault();
        if (!$(".js-validar-cpf-cnpj").hasClass("is-invalid")) {
            $(this).unbind("submit");
            $(this).submit();
        }
    });

    $(".js-cliente-estrangeiro", context).on("change", function () {
        if ($(this).is(":checked")) {
            $(".js-input-documento", context).removeClass("d-none");
            $(".js-input-cpf", context).addClass("d-none");
        } else {
            $(".js-input-documento", context).addClass("d-none");
            $(".js-input-cpf", context).removeClass("d-none");
        }
    });

    $(".js-enviar-senha", context).on("change", function () {
        if ($(this).is(":checked")) {
            $(".js-campos-senha", context).addClass("d-none");
        } else {
            $(".js-campos-senha", context).removeClass("d-none");
        }
    });

    $(".ia-usuario", context).on("change", function () {
        if ($(this).is(":checked")) {
            $(".ia-campos", context).removeClass("d-none");
        } else {
            $(".ia-campos", context).addClass("d-none");
        }
    });

    const $voiceSpeedSlider = $("#eleven_labs_voice_speed", context);
    const $voiceSpeedLabel = $(".js-voice-speed-value", context);
    if ($voiceSpeedSlider.length) {
        $voiceSpeedLabel.text(parseFloat($voiceSpeedSlider.val()).toFixed(1) + "x");
        $voiceSpeedSlider.on("input", function () {
            $voiceSpeedLabel.text(parseFloat(this.value).toFixed(1) + "x");
        });
    }

    $("#form-salvar-usuario").on("submit", function (e) {
        const isIA = $(".ia-usuario").is(":checked");
        const voiceId = $("input[name='eleven_labs_voice_id']").val().trim();

        if (isIA && !voiceId) {
            e.preventDefault();
            $("#overlayer-loading").removeClass("show-overlayer");

            Swal.fire({
                title: "Continuar sem Voice ID?",
                text: "Nenhum Voice ID foi informado. Deseja continuar com o ID padrão?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, continuar",
                cancelButtonText: "Cancelar",
                customClass: {
                    confirmButton: "btn btn-success",
                    cancelButton: "btn btn-secondary",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    $("input[name='eleven_labs_voice_id']").val(
                        "lWq4KDY8znfkV0DrK8Vb"
                    );

                    $("#overlayer-loading").addClass("show-overlayer");

                    $("#form-salvar-usuario").off("submit").submit();
                } else {
                    $("#overlayer-loading").hide();
                    $(".btn").prop("disabled", false);
                }
            });

            return false;
        }
    });

    // Contador de Caracteres
    $(".js-contar-caracteres", context).on("keyup", function (val) {
        $(this).closest(".form-group").find(".js-contador").remove();
        let div = $(this).closest(".form-group");
        let limite = $(div).data("contador");
        let total = this.value.length;

        if (total > limite) {
            this.value = this.value.substring(0, limite);
        } else {
            $(div).append(
                `<span class="label-contador js-contador">${total} de ${limite} caracteres</span>`
            );
        }
    });

    $(".js-contar-caracteres-variante", context).on("keyup", function (val) {
        $(this).closest(".form-group").find(".js-contador").remove();
        let div = $(this).closest(".form-group");
        let limite = $(this).data("contador");
        let total = this.value.length;

        if (total > limite) {
            this.value = this.value.substring(0, limite);
        } else {
            $(div).append(
                `<span class="label-contador js-contador"style="position: absolute; top: -16%;">${total} de ${limite} caracteres</span>`
            );
        }
    });

    $(".js-select-banner", context).on("change", function () {
        if (this.value == 1) {
            $(".banner").removeClass("d-none");
            $(".banner .banner--conteudo").removeClass("fluid");
        } else if (this.value == 2) {
            $(".banner").removeClass("d-none");
            $(".banner .banner--conteudo").addClass("fluid");
        } else {
            $(".banner").addClass("d-none");
        }
    });

    // Input inválido
    $("input.form-control.is-invalid", context).on("focus", function () {
        $(this).removeClass("is-invalid");
    });

    if ($(".js-form-config-loja", context).length) {
        functions.checkTrackingBlock();
    }

    $(".js-botao-adicionar-editar-tarefa", context).on("click", function () {
        const btn = $(this);
        const id = btn.data("id");
        const modalUrl = btn.attr("data-modal-url");

        if (!modalUrl) {
            $(".js-div-mensagem-ativa").addClass("d-none");

            if ($(`#tipo${id}`).val() == "whatsapp") {
                $(`#template_id${id}`).attr("required", true);
                $(".js-div-mensagem-ativa").removeClass("d-none");
            }
            return;
        }

        const abrir = function () {
            const modal = $(`#modalTarefa${id}`);
            modal.find(".js-div-mensagem-ativa").addClass("d-none");
            if (modal.find(`#tipo${id}`).val() == "whatsapp") {
                modal.find("#template_id").attr("required", true);
                modal.find(".js-div-mensagem-ativa").removeClass("d-none");
            }
            modal.modal("show");
        };

        if ($(`#modalTarefa${id}`).length) {
            abrir();
            return;
        }

        if (btn.data("loading")) {
            return;
        }

        btn.data("loading", 1);
        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: modalUrl,
            type: "get",
            success: function (res) {
                btn.data("loading", 0);
                $("#overlayer-loading").removeClass("show-overlayer");
                $("body").append(res);
                const modal = $(`#modalTarefa${id}`);
                if (window.Eloca) {
                    Eloca.load(modal);
                }
                abrir();
            },
            error: function () {
                btn.data("loading", 0);
                $("#overlayer-loading").removeClass("show-overlayer");
            },
        });
    });

    $(".js-data-valida", context).on("change", function () {
        const padrao = new RegExp(
            "^([0-3]){1}([0-9]){1}/([0-1]){1}([0-9]){1}/([0-9]){4}$"
        );
        const valor = $(this).val();
        if (padrao.test(valor)) {
            if ($(this).hasClass("is-invalid")) {
                $(this).removeClass("is-invalid");
            }
        } else {
            if (!$(this).hasClass("is-invalid")) {
                $(this).addClass("is-invalid");
            }
        }
    });

    let tempKeyPressed = "";
    $(".js-telefone-validar-whatsapp", context).on("keyup", function (e) {
        tempKeyPressed += "" + e.key.replace(/\D/g, "");
        let inputVal = $(this).val().replace(/\D/g, "");
        if (inputVal.length < 11) {
            tempKeyPressed = inputVal;
        }

        if (e.ctrlKey && e.which === 86) {
            setTimeout(function () {
                functions.validarTelefone(e, context, tempKeyPressed, true);
            }, 400);
        }
        
    });

    $(".js-telefone-validar-whatsapp", context).on(
        "keyup",
        functions.delay(function (e) {
            functions.validarTelefone(e, context, tempKeyPressed);
        }, 400)
    );

    $(".js-telefone-usuario").on("change", function () {
        const telefone = $(this).val();
        if (!telefone) {
            return;
        }
        buscarRegistroCliente("telefone", telefone, context, $(this));
    });

    $(".js-email-validar", context).on("change", function () {
        const email = $(this).val();
        if (!email) {
            return;
        }

        buscarRegistroCliente("email", email, context, $(this));
    });

    function buscarRegistroCliente(campo, dado, context, input) {
        if($("#usuario_id", context).length > 0) {
            return;
        }
        if (campo != "email") {
            dado = dado.replace(/[^a-zA-Z0-9]/g, "");
        }
        $.ajax({
            url: siteUrl(
                `/painel/clientes/buscar-registro/${campo}/${dado}`
),
            type: "GET",
            dataType: "json",
            success: function (response) {
                if (response.success && response.clienteId !== null) {
                    input.val('');
                    $(".js-mensagem-cliente-existente", context).html(response.mensagem);
                    if (response.ativo) {
                        $(".js-acessar-cliente", context).attr(
                            "data-url",
                            siteUrl(`/painel/clientes/${response.clienteId}`)
                        );
                    }
                    if (!response.ativo) {
                        $(".js-acessar-cliente", context).attr(
                            "data-url",
                            siteUrl(
                                `/painel/clientes/restaurar/${response.clienteId}`
                            )
                        );
                    }
                    $("#modalClienteExistente").modal("show");
                }
            },
            error: function (err) {
                showToastDanger(context, err.mensagem);
            },
        });
    }
    $(".js-acessar-cliente", context).on("click", function() {
        const url = $(this).attr('data-url');
        window.location.href = url;
    });

    $(".js-form-obrigatorio", context).on("invalid", function (e) {
        if (!$(this).hasClass("is-invalid")) {
            $(this).addClass("is-invalid");
        }
        const tab = $(this).data("id");
        if (tab) {
            $(`#${tab}`).click();
        }
    });

    $(".js-form-obrigatorio", context).on("valid", function (e) {
        if ($(this).hasClass("is-invalid")) {
            $(this).removeClass("is-invalid");
        }
    });
}
